var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-shell"},[_c('div',{staticClass:"data-icon",style:('width: '+_vm.width+';height: '+_vm.height+';')},[_c('img',{attrs:{"src":_vm.icon,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }